/*
 * use-battery
 */
import { useEffect, useState } from "react"

export type BatteryState = {
	isSupported: boolean
	hasBattery: boolean
	loading: boolean
	state: Battery | null
}

export type Battery = {
	level: number
	charging: boolean
	chargeTime: number
	dischargeTime: number
}

export function useBattery(): BatteryState {
	const [state, setState] = useState<BatteryState>({
		isSupported: (window.navigator as any)?.getBattery ? true : false,
		hasBattery: false,
		loading: true,
		state: null,
	})

	useEffect(() => {
		if (!(navigator as any)?.getBattery) {
			setState({
				isSupported: false,
				hasBattery: false,
				loading: false,
				state: null,
			})
			return
		}

		let battery: any = null
		let hasBattery = false

		function handleChange() {
			setState({
				hasBattery,
				isSupported: true,
				loading: false,
				state: battery,
			})
		}

		;(navigator as any).getBattery().then((b: any) => {
			battery = b
			hasBattery = !!battery && (battery.dischargeTime || battery.chargingTime)
			handleChange()

			battery.addEventListener("levelchange", handleChange)
			battery.addEventListener("chargingchange", handleChange)
			battery.addEventListener("chargingtimechange", handleChange)
			battery.addEventListener("dischargingtimechange", handleChange)
		})

		return () => {
			if (battery) {
				battery.removeEventListener("levelchange", handleChange)
				battery.removeEventListener("chargingchange", handleChange)
				battery.removeEventListener("chargingtimechange", handleChange)
				battery.removeEventListener("dischargingtimechange", handleChange)
			}
		}
	}, [])

	return state
}
